<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <div style="padding-left: 32px">
        <h5 class="dialogTitle">
          Sửa sai thông tin văn bản
        </h5>
        <div class="group__info" style="margin-bottom: 0;">
          <div class="title font-size__medium">
            Thông tin văn bản
          </div>
        </div>
      </div>
    </template>

    <template #body>
      <div style="max-height: 700px">
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="150px"
        >
          <el-row :gutter="24">
            <el-col :span="24">
              <div class="file-uploaded input-none__border" v-if="form.attachmentFiles.length > 0">
                <div class="file-uploaded">
                  <div class="file clickable flex-row flex__between">
                    <a v-openInNewTab
                       :href="getToken(form.attachmentFiles[0].id) | buildAttachmentURL({type: DOWNLOAD_OPTION.TYPE.ORIGINAL})"
                       class="flex-row flex__left"
                    >
                      <fileTypeImage
                        :fileExtention="form.attachmentFiles[0].fileExtention"
                        :customClass="'icon-small margin-right-10'"
                      />
                      <span class="fileName font-weight_normal">{{form.attachmentFiles[0].fileName}}</span>
                    </a>
                    <i
                      class="el-icon-circle-close margin-left-10 font-size__large color__red"
                      @click="removeUploadAttachment"
                    ></i>
                  </div>
                </div>
              </div>

              <el-form-item prop="attachment" class="input-no__label" style="margin-bottom: 12px;" v-else>
                <el-upload
                  class="upload-demo style-fullWidth input-border__bottom input-border__radius__0"
                  drag
                  :action="uploadAttachmentURL"
                  size="mini"
                  :on-success="uploadAttachmentSuccess"
                  :data="uploadAttachmentAdditionalData"
                  :file-list="form.attachmentFiles"
                  :show-file-list="false"
                  :headers="uploadAttachmentHeaders"
                  accept="application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  :before-upload="
                    file =>
                      newValidateUploadFile(
                        file,
                        {
                          acceptFileTypes: 'application/pdf'
                        },
                        buildMessageUploadOnlyPdf()
                      )
                  "
                  :on-error="onUploadError"
                  :on-change="() => (isUploadingDocFlag = true)"
                  v-loading="isUploadingDocFlag && isUploading"
                >
                  <div class="el-upload__text">
                    <p class="margin-0 padding-0">
                      Tải file đính kèm
                      <span class="font-italic font-size__small color__red">{{ "(Định dạng file pdf)" }}</span>
                    </p>
                    <i class="fas fa-cloud-upload color__blue font-size__large" />
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="Trích yếu văn bản" prop="quote">
                <el-input
                  v-model="form.quote"
                  placeholder="Trích yếu văn bản"
                  class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Số ký hiệu" class="margin-top-10" prop="docCode">
                <el-input
                  v-model="form.docCode"
                  placeholder="Số ký hiệu"
                  class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                  size="medium"
                  maxlength="100"
                  show-word-limit
                  :disabled="!isKyNgoai"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Ngày ban hành" class="margin-top-10" prop="docDate">
                <el-date-picker
                  class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                  v-model="form.docDate"
                  type="date"
                  :prefix-icon="' '"
                  placeholder="dd/mm/yyyy"
                  format="dd/MM/yyyy"
                  :disabled="!isKyNgoai"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Loại văn bản" class="margin-top-10" prop="docTypeId">
                <el-select
                  clearable
                  class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                  v-model="form.docTypeId"
                  filterable
                  placeholder="Loại văn bản"
                >
                  <el-option
                    v-for="item in docTypes"
                    :key="item.id"
                    :label="item.categoryName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Độ khẩn" class="margin-top-10" prop="priorityId">
                <el-select
                  clearable
                  class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                  v-model="form.priorityId"
                  filterable
                  placeholder="Độ khẩn"
                >
                  <el-option
                    v-for="item in priorities"
                    :key="item.id"
                    :label="item.categoryName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Hạn xử lý" class="margin-top-10" prop="deadlineDate">
                <el-date-picker
                  class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                  v-model="form.deadlineDate"
                  type="date"
                  :prefix-icon="' '"
                  placeholder="dd/mm/yyyy"
                  format="dd/MM/yyyy"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Số trang" class="margin-top-10" prop="numberOfPage">
                <el-input-number
                  size="mini"
                  class="style-fullWidth input-font__bold"
                  v-model="form.numberOfPage"
                  placeholder="-"
                  :controls="true"
                  :min="0"
                  :step="1"
                  :precision="0"
                  :max="1000"
                >
                </el-input-number>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="Người ký duyệt" class="margin-top-10" prop="signerUserDeptRoleId">
                <el-select
                  clearable
                  class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                  v-model="form.signerUserDeptRoleId"
                  filterable
                  placeholder="Người ký duyệt"
                  :disabled="!isKyNgoai"
                >
                  <el-option
                    v-for="item in signerUserDeptRoles"
                    :key="item.id"
                    :label="signerLabel(item)"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="Đơn vị thực hiện" class="margin-top-10" prop="deptEditorId">
                <el-select
                  clearable
                  class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                  v-model="form.deptEditorId"
                  filterable
                  placeholder="Đơn vị thực hiện"
                  :disabled="!isKyNgoai"
                >
                  <el-option
                    v-for="item in editorDepartments"
                    :key="item.id"
                    :label="item.deptName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="Ghi chú" class="margin-top-10" prop="note">
                <el-input
                  type="textarea"
                  v-model="form.note"
                  placeholder="Ghi chú"
                  class="input-border__bottom input-border__radius__0 style-fullWidth"
                  size="medium"
                  maxlength="2000"
                  show-word-limit
                  :autosize="{ minRows: 2, maxRows: 5 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <doc-relations-form
          :title="'Văn bản liên quan không ban hành kèm'"
          :attachedType="DOC_RELATION_ATTACHED_TYPE.NO_ATTACHED"
          :docId="id"
          ref="noAttachedDocRelationsForm"
        ></doc-relations-form>

        <doc-relations-form
          :title="'Văn bản liên quan ban hành kèm'"
          :attachedType="DOC_RELATION_ATTACHED_TYPE.ATTACHED"
          :docId="id"
          ref="attachedDocRelationsForm"
        ></doc-relations-form>
      </div>

    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Cập nhật
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
  import constants from "../../constants";
  import errorMessageFilter from "../../filters/errorMessageFilter";
  import categoryViewService from "../../services/categoryViewService";
  import departmentService from "../../services/departmentService";
  import outgoingDocService from "../../services/outgoingDocService";
  import userDeptRoleViewService from "../../services/userDeptRoleViewService";
  import utils from "../../services/utils";
  import CustomDialog from "../common/custom-dialog";
  import handleRequestErrorMixin from "../handleRequestErrorMixin";
  import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
  import attachmentService from "../../services/attachmentService";
  import uploadFileMixin from "../doc-in/uploadFileMixin";
  import DocRelationsForm from "./doc-relations-form";

  export default {
    name: "vb-outgoing-doc-sua-sai-bh-dialog-v2",
    mixins: [handleRequestErrorMixin, vbAttachmentTokenMixin, uploadFileMixin],
    props: ["isOpen", "id"],
    components: {
      CustomDialog,
      DocRelationsForm,
      fileTypeImage: () => import("../job/FileTypeImage"),
    },

    data() {
      return {
        DOC_RELATION_ATTACHED_TYPE: constants.DOC_RELATION_ATTACHED_TYPE,

        rules: {
          attachment: null,
          quote: null,
          docTypeId: null,
          priorityId: null,
          docCode: null,
          docDate: null,
          numberOfPage: null,
          signerUserDeptRoleId: null,
          deptEditorId: null,
          deadlineDate: null,
          note: null
        },
        form: {
          quote: null,
          docTypeId: null,
          priorityId: null,
          docCode: null,
          docDate: null,
          numberOfPage: null,
          signerUserDeptRoleId: null,
          deptEditorId: null,
          deadlineDate: null,
          note: null,
          attachmentId: null,
          attachmentFiles: []
        },
        vbOutgoingDoc: null,
        docTypes: [],
        priorities: [],
        signerUserDeptRoles: [],
        editorDepartments: [],

        isUploadingDocFlag: null,
        objectTypeFinalByObjectId:2

      };
    },

    computed: {
      deptId() {
        return this.$store.getters.userDeptRole.deptId;
      },

      isKyNgoai() {
        return this.vbOutgoingDoc && this.vbOutgoingDoc.isKyNgoai === constants.TRUE;
      },

      uploadAttachmentAdditionalData() {
        return {
          objectType: constants.ATTACHMENT_OBJECT_TYPE.VB_DI,
          note: ""
        };
      },
    },

    watch: {
      objectTypeFinalByObjectId(){
        this.loadAttachment()
      }
    },

    async created() {
      this.initValidationRules();
      await Promise.all([
        this.loadDocTypes(),
        this.loadPriorities(),
        this.loadVbOutgoingDoc(),
        this.loadAttachment()
      ]);
      this.loadObjectTypeFinalByObjectId()
      await Promise.all([
        this.loadDepartments(),
        this.loadSignerUserDeptRoles()
      ])
      this.bindDataToForm();
    },

    methods: {
      // Attachment
      loadAttachment() {
        return attachmentService.findAll({
          objectId: this.id,
          objectType:this.objectTypeFinalByObjectId
        })
          .then(res => {
            if (res.data && res.data.length > 0) {
              this.form.attachmentFiles = res.data
              this.form.attachmentId = res.data[0].id
            }
          })
      },

      removeUploadAttachment() {
        this.form.attachmentFiles = [];
        this.form.attachmentId = null
      },

      uploadAttachmentSuccess(vbAttachment) {
        return this.onUploadSuccess(vbAttachment)
          .then(response => {
            this.removeUploadAttachment();
            this.form.attachmentFiles.push(response);
            this.form.attachmentId = response.id;
            this.form.numberOfPage = response.pageNumber;
          }
        )
      },

      buildMessageUploadOnlyPdf() {
        return errorMessageFilter({errorCode: "file.onlyAllowPdf"});
      },

      loadDepartments() {
        return departmentService
          .findAll({sort: "deptName,asc"})
          .then(response => {
            this.departments = response.data || [];
            this.editorDepartments = departmentService.prepareEditorDepartments(
              this.vbOutgoingDoc.publisherId,
              this.departments
            );
          });
      },

      loadSignerUserDeptRoles() {
        if (this.isKyNgoai) {
          return userDeptRoleViewService
            .findAllSignerForCreateKyNgoai(this.deptId)
            .then(response => {
              this.signerUserDeptRoles = response.data || [];
              this.signerUserDeptRoles.sort((item1, item2) =>
                utils.compareUserDeptRoleView(item1, item2)
              );
            });
        }

        return userDeptRoleViewService.findById(this.vbOutgoingDoc.signerUserDeptRoleId)
          .then(res => this.signerUserDeptRoles = [res.data])
      },

      loadDocTypes() {
        return categoryViewService
          .findAllByGroupCode(constants.CATEGORY_GROUP_CODE.DOC_TYPE)
          .then(response => (this.docTypes = response.data));
      },

      loadPriorities() {
        return categoryViewService
          .findAllByGroupCode(constants.CATEGORY_GROUP_CODE.PRIORITY)
          .then(response => (this.priorities = response.data));
      },

      signerLabel(userDeptRoleView) {
        return utils.buildUserDeptRoleViewLabel(userDeptRoleView);
      },

      loadVbOutgoingDoc() {
        return outgoingDocService
          .findById(this.id)
          .then(response => (this.vbOutgoingDoc = response.data));
      },

      bindDataToForm() {
        this.form.quote = this.vbOutgoingDoc.quote;
        this.form.docTypeId = this.vbOutgoingDoc.docTypeId;
        this.form.priorityId = this.vbOutgoingDoc.priorityId;
        this.form.docCode = this.vbOutgoingDoc.docCode;
        this.form.docDate = this.vbOutgoingDoc.docDate
          ? new Date(this.vbOutgoingDoc.docDate)
          : null;
        this.form.numberOfPage = this.vbOutgoingDoc.numberOfPage;
        this.form.signerUserDeptRoleId = this.vbOutgoingDoc.signerUserDeptRoleId;
        this.form.deptEditorId = this.vbOutgoingDoc.deptEditorId;
        this.form.deadlineDate = this.vbOutgoingDoc.deadlineDate
          ? new Date(this.vbOutgoingDoc.deadlineDate)
          : null;
      },

      initValidationRules() {
        let defaultRequiredConstrains = {
          required: true,
          message: "Trường dữ liệu bắt buộc",
          trigger: "blur"
        };
        this.rules.attachment = [defaultRequiredConstrains];
        this.rules.quote = [defaultRequiredConstrains];
        this.rules.deptEditorId = [defaultRequiredConstrains];
        this.rules.docCode = [defaultRequiredConstrains];
        this.rules.docDate = [defaultRequiredConstrains];
        this.rules.note = [defaultRequiredConstrains];
      },

      validateForm() {
        return utils.validateFormCommon(this.$refs.form, this.$message);
      },

      convertToSubmitForm() {
        let docRelations = [];
        docRelations.push(
          ...(this.$refs.noAttachedDocRelationsForm.getRelationDocs() || [])
        );
        docRelations.push(
          ...(this.$refs.attachedDocRelationsForm.getRelationDocs() || [])
        );

        return {
          attachmentId: this.form.attachmentId,
          quote: this.form.quote,
          docTypeId: this.form.docTypeId,
          priorityId: this.form.priorityId,
          docCode: this.form.docCode,
          docDate: this.form.docDate ? this.form.docDate.getTime() : null,
          numberOfPage: this.form.numberOfPage,
          signerUserDeptRoleId: this.form.signerUserDeptRoleId,
          deptEditorId: this.form.deptEditorId,
          deadlineDate: this.form.deadlineDate
            ? this.form.deadlineDate.getTime()
            : null,
          note: this.form.note,
          docRelation: docRelations
        };
      },

      submit() {
        this.validateForm()
          .then(() => {
            let submitForm = this.convertToSubmitForm();
            return outgoingDocService
              .suaSaiBanHanh(this.id, submitForm)
              .then(response => response.data);
          })
          .then(vbOutgoingDoc => {
            this.$message.success(
              errorMessageFilter({
                errorCode: "vbOutgoingDoc.updateSuccess"
              })
            );
            this.$emit("updateSuccess", {result: vbOutgoingDoc});
          })
          .catch(error => {
            this.commonHandleRequestError(error);
            throw error;
          });
      },
      loadObjectTypeFinalByObjectId() {
        return attachmentService.getObjectTypeFinalByObjectId(
          this.id,
        )
          .then(res => {
            if (res && res.data) {
              this.objectTypeFinalByObjectId = res.data

            }
          })
      },
    }
  };
</script>

<style type="text/css" scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/vb-outgoing-doc-sua-sai-bh-dialog-v2.vue